import { queryOptions } from '@tanstack/react-query';
import { container } from '@intigral/domain/lib/DataDomain';
import { ICustomConfigurationService } from '@intigral/domain/lib/application/services/CustomConfigurationService';
import { DI } from '@intigral/constant/config/DIContainer';
import { getTransformedCategories } from '../components/elements/moods/helper';
// Query key factory for mood-related queries
export const moodsQueryKeys = {
    all: ['moods'] as const,
    configuration: () => [...moodsQueryKeys.all, 'configuration'] as const,
    channels: (mood: any) => [...moodsQueryKeys.all, 'channels', mood?.id] as const,
    lucky: () => [...moodsQueryKeys.all, 'lucky'] as const,
    vod: (category: any) => [...moodsQueryKeys.all, 'vod', category?.id] as const,
};

// Query options for mood configuration
export const moodsConfigurationQueryOptions = () =>
    queryOptions({
        queryKey: moodsQueryKeys.configuration(),
        queryFn: async () => {
            try {
                const customConfigService = container.resolve<ICustomConfigurationService>(
                    DI.SERVICES.ICustomConfigurationService
                );
                const response = await customConfigService.getMoods();
                const transformedData = getTransformedCategories(response?.data || []);
                return transformedData;
            } catch (error) {
                throw new Error('Failed to fetch moods configuration');
            }
        },
        staleTime: 60 * 60 * 1000, // 1 hour
        gcTime: 60 * 60 * 1000, // 1 hour
        retry: 3,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
